// A reader's search term reaches MySQL inside a boolean-mode `MATCH ... AGAINST`,
// where `+ - > < ( ) ~ * " @` are operators rather than characters to match. Left
// in, a stray one makes the whole query a syntax error and MySQL rejects it — so
// a term like `/wedding-planning/readings/dust-` takes the page down instead of
// simply missing. Strip them, then collapse the whitespace they leave behind.
//
// Shared by every full-text search that takes reader input: articles and
// suppliers sanitise identically, so the same query behaves the same on both
// halves of `/search`.
export const toBooleanModeTerm = (search: string) =>
  search
    .replace(/[+\-><()~*"@]/g, ' ')
    .trim()
    .replace(/\s+/g, ' ')
